// Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import {
  SvgIcon
} from '../'

import {
  EventContext
} from '../../context'

class EventListItemRenderer extends React.PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
      node: PropTypes.shape({
        eventType: PropTypes.string.isRequired,
        eventAt: PropTypes.string.isRequired,
        eventData: PropTypes.string.isRequired
      })
    })),
    index: PropTypes.number.isRequired,
    style: PropTypes.object
  }

  render() {
    const { data, index, style } = this.props
    const item = data[index].node

    return (
      <EventContext.Consumer>
        {({ eventId, changeEventId }) => (
          <WhatsappMessageEventListItem
            eventType={item.eventType}
            eventAt={moment(item.eventAt).format('DD MMM YYYY HH:mm:ss')}
            onClick={() => changeEventId(item.id)}
            selected={eventId === item.id}
            style={style}
          />
        )}
      </EventContext.Consumer>
    )
  }
}

export default EventListItemRenderer

const getEventListIconName = (whatsappMessageEventType) => {
  switch(whatsappMessageEventType) {
    case 'picsaos.request':
      return 'product_transfer'
    case 'whatsappmessage.parsed':
      return 'custom'
    case 'whatsappmessage.user_state':
      return 'user'
    case 'whatsappmessage.processed':
      return 'resource_preference'
    case 'whatsappmessage.sending':
      return 'sales_path'
    default:
      return 'event'
  }
}

class WhatsappMessageEventListItem extends React.PureComponent {
  render() {
    const { eventType, eventAt, onClick, selected, style } = this.props
    const eventIconName = getEventListIconName(eventType)

    return (
      <div className='timeline-item' style={{ ...style, cursor: 'pointer' }} onClick={onClick}>
        <div className={`slds-media${selected ? ' item-selected' : ''}`} style={{ alignItems: 'center' }}>
          <div className="slds-media__figure slds-p-left_xx-small">
            <div className="slds-icon_container timeline-item_icon" title="task">
              <SvgIcon
                variant='standard'
                symbol={eventIconName}
                size='small'
                colour='inverse'
                bare={false}
              />
            </div>
          </div>
          <div className="slds-media__body">
            <div
              className="slds-grid slds-grid_align-spread timeline-item_trigger"
              style={selected ? { pointerEvents: 'none'} : {}}>
              <div className="slds-grid slds-grid_vertical-align-center slds-truncate_container_75 slds-no-space">
                <h3 className="slds-truncate">
                  <strong>{eventType}</strong>
                </h3>
              </div>
              <div className="slds-timeline__date">
                {eventAt}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/whatsapp-message-events-list/EventListItemRenderer.js